module.exports = __webpack_public_path__ + "img/ktb-1.0b8889d3.png";